﻿( function( doc ) {
	'use strict';

	class ContactUs {
		constructor() {
			this.providerId = -1;
			this.prvContainer = app.$( '#prv-container' );
			this.prvOptions = app.$( '#prv-options' );
			this.loadProviders();
			this.loadOptions();
			this.handleContactForm();
		}

		hideItems() {
			this.prvRow = app.$$( '.provider-row' );
			this.prvRow.forEach( function( value ) {
				value.classList.add( 'hidden' );
			} );
		}

		loadProviders() {
			app.$.fetch( 'api/providersGetForView', {
				body: {
					providerId: this.providerId
				}
			} ).then( rsp => {

				if ( rsp.success ) {
					this.prvContainer.innerHTML = rsp.obj;
					this.hideItems();
					this.scrollSelect();
				} else {
					console.log( rsp.msg );
				}

			} );
		}

		loadOptions() {
			app.$.fetch( 'api/providerGetOptions', {
				body: {
					emptyMsg: 'Show All Providers'
				}
			} ).then( rsp => {

				if ( rsp.success ) {
					this.prvOptions.innerHTML = rsp.obj;
				} else {
					console.log( rsp.msg );
				}

			} );
		}

		scrollSelect() {

			if ( this.prvOptions ) {
				this.prvOptions.addEventListener( 'change', (e) => this.showItem(e) );
			}
		}

		showItem() {

			this.hideItems();
			let itemVal = this.prvOptions.options[this.prvOptions.selectedIndex].value;
			let divItem = doc.getElementById( itemVal );
			divItem.classList.toggle( 'hidden' );
		}

		handleContactForm() {
			const formEl = app.$( '#form-contact' );
			const btnSubmit = app.$( '#btn-submit' );
			const form = new app.Form( formEl );
			let isProcessing = false;

			btnSubmit.addEventListener( 'click', ( e ) => {
				if ( isProcessing ) {
					return;
				}
				
				isProcessing = true;
				const isValid = form.validateFields();

				if ( !isValid ) {
					window.alert( 'fields marked with asterisk are required' );
					isProcessing = false;
					return;
				}

				btnSubmit.textContent = 'Submitting...';
				let params = form.collectData();

				app.$.fetch( '/api/contactFormSubmit', {
					body: params

				} ).then(rsp => {
					
					if ( rsp.success ) {
						formEl.innerHTML = '<p>Thank you. Your form has been submitted.</p>';
					} else {
						btnSubmit.textContent = 'Submit';
						isProcessing = false;
					}
				});

			} );
		}

	}

	let cp = new ContactUs();

} )( document );